import { ReaderNavigationContext } from "../../screens/reader/types";

export type NavigationAnalyticsAttribution = {
  impressionId?: string;
  searchQueryId?: string;
};

export function getNavigationAnalyticsAttribution(
  navigationContext?: ReaderNavigationContext,
): NavigationAnalyticsAttribution {
  return {
    impressionId: navigationContext?.impressionId,
    searchQueryId: navigationContext?.searchQueryId,
  };
}

export function applyNavigationAnalyticsAttribution(
  navigationContext: ReaderNavigationContext | undefined,
  attribution: NavigationAnalyticsAttribution,
): ReaderNavigationContext | undefined {
  if (!attribution.impressionId && !attribution.searchQueryId) {
    return navigationContext;
  }

  return {
    ...(navigationContext ?? {}),
    ...(attribution.impressionId
      ? { impressionId: attribution.impressionId }
      : {}),
    ...(attribution.searchQueryId
      ? { searchQueryId: attribution.searchQueryId }
      : {}),
  };
}
